import { css } from "lit";

export const ganttCellStyles = css`
  @import url("/src/styles/tokens.css");

  :host {
    display: block;
    position: relative;
    height: 100%;
  }

  .cell-content {
    min-height: 44px;
    height: 100%;
    position: relative;
    padding: var(--space-1) var(--space-1);
    display: flex;
    flex-direction: column;
    gap: var(--space-1);
    overflow: auto;
  }

  .cohort-start-marker {
    position: absolute;
    top: var(--space-2);
    left: var(--space-2);
    background: var(--color-primary-500);
    color: var(--color-white);
    font-size: 0.6rem;
    padding: 2px 6px;
    border-radius: var(--radius-full);
    font-weight: var(--font-weight-semibold);
    z-index: 1;
    box-shadow: none;
    pointer-events: none;
  }

  /* available-teachers overlay moved to column headers */
`;
